import { make } from "vuex-pathify";
import GraphQL from "../../api/graphql";

const state = {
    titleDefault: null,
    earliestDate: null,
    latestDate: null,
    creators: [],
    level: "",
    levels_name: false,
    levels_id: false,
    levels_fathers: false,
    transcription: null,
    images: [],
    videos: [],
    documents: [],
    audios: [],
    comments: [],
    startAudioAt: 0,
    startImageAt: 0,
    startVideoAt: 0,
    id: null,
    highlight: []
};

const mutations = make.mutations(state);

const actions = {
    async createComment({ rootState, dispatch }, { documentId, comment }) {
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        await client.query({
            query: `
                mutation($comment: String!, $documentId: ID!) {
                    createComment(comment: $comment, document_id: $documentId)
                }
            `,
            variables: {
                comment,
                documentId
            }
        });

        await dispatch("fetchById", documentId);
    },
    async getLevelsFoldersByDocument({rootState}, payload = {}) {
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const id = parseInt(payload.id);

        const response = await client.query({
            query: `{
                getLevelsFoldersByDocument(id: ${id}) {
                        fathers {
                            id,
                            name
                        }
                        fund {
                            id,
                            name
                        }
                    }
            }`,
            variables: {
                id
            }
        });

        if (response.data.getLevelsFoldersByDocument !== null) {
            this.set("document/levels_fathers", response.data.getLevelsFoldersByDocument.fathers);
            this.set("document/levels_name", response.data.getLevelsFoldersByDocument.fund.name);
            this.set("document/levels_id", response.data.getLevelsFoldersByDocument.fund.id);
        } else {
            this.set("document/levels_fathers", false);
            this.set("document/levels_name", false);
            this.set("document/levels_id", false);
        }
    },
    async fetchById({ rootState }, id) {
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const response = await client.query({
            query: `
                query($id: ID!) {
                    viewDocument(id: $id) {
                        
                            title_default
                            latest_date
                            earliest_date
                            transcription
                            creators
                            level
                            images {
                                uri
                                transcription
                                id
                            }
                            videos {
                                uri
                                transcription
                                
                            }
                            documents
                            audios {
                                uri
                                transcription
                                
                            }
                        
                    }

                    documentComments(document_id: $id) {
                        id
                        comment
                        user {
                            name
                        }
                        created_at
                    }

                }
            `,
            variables: {
                id
            }
        });

        const data = response.data.viewDocument;
        const images = data.images;
        const comments = response.data.documentComments.map(comment => {
            return {
                id: comment.id,
                username: comment.user.name,
                content: comment.comment,
                createdAt: comment.created_at
            };
        });

        this.set("document/id", id);
        this.set("document/titleDefault",  data.title_default);
        this.set("document/earliestDate", data.earliest_date);
        this.set("document/latestDate", data.latest_date);
        this.set("document/creators", data.creators);
        this.set("document/level", data.level);
        this.set("document/transcription", data.transcription);
        this.set("document/images", images);
        this.set("document/videos", data.videos);
        this.set("document/documents", data.documents);
        this.set("document/audios", data.audios);
        this.set("document/comments", comments);
    },
    reset() {
        this.set("document/titleDefault", null);
        this.set("document/earliestDate", null);
        this.set("document/latestDate", null);
        this.set("document/creators", []);
        this.set("document/level");
        this.set("document/transcription", null);
        this.set("document/images", []);
        this.set("document/videos", []);
        this.set("document/documents", []);
        this.set("document/audios", []);
    }
};

export default { state, mutations, actions };
